import React from 'react';
import PropTypes from 'prop-types';

const Phone = ({ width, className }) => (
  <svg
    width={width}
    height={width}
    className={className}
    viewBox="0 0 18 18"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M5.5 3.5H7L8.5 7L7.25 8.25C8.1 10.2 9.8 11.9 11.75 12.75L13 11.5L16.5 13V14.5C16.5 15.05 16.05 15.5 15.5 15.5C8.5 15.5 2.5 9.5 2.5 2.5C2.5 1.95 2.95 1.5 3.5 1.5H5.5V3.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

Phone.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

Phone.defaultProps = {
  width: 18,
  className: '',
};

export default Phone;
